import React from 'react';
import MaterialButton from '@mui/material/Button';
import c from 'classnames';

import { BaseButtonProps } from './types';

const BaseButton = React.forwardRef<HTMLButtonElement, BaseButtonProps>((props, ref) => {
  const { className, ...rest } = props;

  return (
    <MaterialButton ref={ref} className={c('normal-case tracking-normal', className)} {...rest} />
  );
});

export default BaseButton;
